import { Component, HostBinding, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { selectVersionId } from 'demand-forecasting/store/router-state/router.selectors';

@Component({
  selector: 'pm-no-version-id-provided',
  template: `<div class="flex flex-col justify-center">
    <h1 class="opacity-60 font-semibold">
      {{ 'UTILITY.PLEASE_SELECT_FORECAST_VERSION_HINT' | translate }}
    </h1>
  </div>`,
  styles: [],
  imports: [TranslateModule],
})
export class NoVersionIdProvidedComponent {
  private readonly store = inject(Store);
  public versionId = this.store.selectSignal(selectVersionId);

  @HostBinding('class')
  get hostClasses() {
    return 'flex flex-row flex-1 justify-start';
  }
}
